module.exports = __webpack_public_path__ + "img/UHEFozdoChapeco2.3f13bc88.jpg";